import { Offer } from '@interfaces/offer';

export const SELECTED_OFFERS_LOCAL_STORAGE_PREFIX = 'selected-offers';

export function getSelectedOffers(key: string): OfferIds | null {
  const ls = localStorage.getItem(key);
  return ls ? JSON.parse(ls) : null;
}

function deleteSelectedOffers(key: string) {
  localStorage.removeItem(key);
}

function getSelectedOffersKeys(): string[] {
  return JSON.parse(
    localStorage.getItem(SELECTED_OFFERS_LOCAL_STORAGE_PREFIX) || '[]',
  );
}

function appendToSelectedOffersKeys(key: string) {
  const selectedOffersKeys = getSelectedOffersKeys();
  selectedOffersKeys.push(key);
  localStorage.setItem(
    SELECTED_OFFERS_LOCAL_STORAGE_PREFIX,
    JSON.stringify(selectedOffersKeys),
  );
}

export function setSelectedOffers(key: string, ids: OfferIds) {
  localStorage.setItem(key, JSON.stringify(ids));
  appendToSelectedOffersKeys(key);
}

export function clearSelectedOffers() {
  const keys = getSelectedOffersKeys();
  keys.forEach((key: string) => deleteSelectedOffers(key));
  deleteSelectedOffers(SELECTED_OFFERS_LOCAL_STORAGE_PREFIX);
}

export function removeIdsFromAllSelectedOffers(ids: OfferIds) {
  const keys = getSelectedOffersKeys();
  keys.forEach((key) => {
    const selectedOffers = getSelectedOffers(key);
    if (!selectedOffers) return;

    const filteredOffers = selectedOffers.filter((id) => !ids.includes(id));
    setSelectedOffers(key, filteredOffers);
  });
}

type OfferIds = Offer['id'][];
